{
  "breadcrumbs": [
    {
      "text": "Hjem",
      "url": "/"
    },
    {
      "text": "Oversikt over cookies i bruk på scoopr.no",
      "url": null
    }
  ],
  "content": "\n<p>Noen ganger bruker vi informasjonskapsler, såkalte cookies, (inkludert permanente informasjonskapsler som blir værende på enheten din) og annen sporingsteknologi («Informasjonskapsler»), som er små filer som lagres på datamaskinen din, og som brukes til å innhente informasjon mens du besøker Scooprs nettsted, for eksempel om hvilke spesifikke deler av nettstedet du benytter. Vi innhenter denne informasjonen for å forbedre innholdet og tjenestene vi tilbyr, og for å kunne skreddersy nettstedet og tjenestene våre etter dine behov og ønsker. Informasjonskapsler kan også bidra til at nettstedet fungerer bedre og raskere neste gang du besøker det. Ved å fortsette bruken av vår tjeneste aksepterer du dette.</p>\n\n\n\n<p>Du kan innstille nettleseren din til å oppdage og fjerne Informasjonskapsler. Hvis du velger ikke å godta Informasjonskapsler, risikerer du imidlertid at du ikke får tilgang til alle funksjonene på nettstedet. Du finner mer informasjon i nettleserens hjelpefunksjon.</p>\n",
  "subtitle": null,
  "title": "Cookies",
  "tableData": [
    {
      "choice": "Valgfri",
      "name": "_gat_UA-85713726-1",
      "purpose": "Brukes for å strupe antall forespørsler og begrense innsamling av data på høyt trafikkerte områder",
      "receiver": "Google Universal Analytics",
      "storage": "1 dag"
    },
    {
      "choice": "Valgfri",
      "name": "_fbp",
      "purpose": "Cookie som brukes av Facebook til å levere forskjellige reklame-tjenester.",
      "receiver": "Facebook",
      "storage": "90 dag"
    },
    {
      "choice": "Valgfri",
      "name": "_ga",
      "purpose": "Informasjonskapsler knyttet til Universal Analytics registrerer hvor du kom fra, hvor mange ganger du har besøkt sidene våre og hvor lenge du ble der. Vi anonymiserer IP-adressen din, slik at din identitet ikke kan spores.",
      "receiver": "Google Analytics",
      "storage": "2 år"
    }
  ]
}
